import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
//primeReact
import { Button } from "primereact/button";
//components

//imports
import Modal from "../../../../../../components/modal/Modal";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { formatCurrency } from "../../../../../../utils/formatCurrency";
import { formatDate } from "../../../../../../utils/formatDate";
import { useParcelContext } from "./ParcelContext";
import { FilterMatchMode } from "primereact/api";
import { postReverseInstallment } from "../../../../../../services/Report/postReverseInstallment";
import { confirmDialog } from "primereact/confirmdialog";
import { generateShipping } from "../../../../../../services/Parcel/generateShipping";
import { postReversalShipping } from "../../../../../../services/Financial/postReversalShipping";


const ModalReverseShipping = ({ dynamicTitle }) => {
  const { handleSubmit: handleUpdateParcel } = useForm();

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [selectedCustomers, setSelectedCustomers] = useState([]);

  const [selectAll2, setSelectAll2] = useState(false);

  const {
    idSale,
    enterpriseId,
    setItemsSelected,
    isModalVisibleReverseShipping,
    setIsModalVisibleReverseShipping,
    refetch,
    parcels
  } = useParcelContext();

  const shippingWithError = parcels?.filter(row => row.shipping == 4).map(row => {
    return row;
  });

  const totalRecords = shippingWithError?.length;


  const style = {
    width: window.innerWidth <= 992 ? "95vw" : "95vw",
  };
  // eslint-disable-next-line no-unused-vars
  const onGlobalFilterChange = (e) => {
    setGlobalFilterValue(e.target.value);
  };
  const onSelectAllChange = (event) => {
    setSelectAll2(event.checked);
    // console.log(event);
    if (event.checked) {
      // Se o checkbox de seleção estiver marcado, selecionar todos os registros
      setSelectedCustomers(shippingWithError);
    } else {
      // Se o checkbox de seleção estiver desmarcado, desmarcar todos os registros
      setSelectedCustomers([]);
    }
  };
  const onSelectionChange = (event) => {
    // console.log(event);
    const value = event.value;
    setSelectedCustomers(value);
    setSelectAll2(value.length === totalRecords);
  };
  //COLUNAS DA TABELA
  const columns = [
    { field: "id", header: "ID" },
    { field: "sequence_number", header: `N° Parcela` },
    {
      field: "description.name",
      header: `Descrição`,
    },
    {
      field: "value",
      header: "Valor Parcela",
      body: (rowData) => formatCurrency(rowData.value),
    },
    {
      field: "status",
      header: "Situação",
      body: (rowData) => {
        let labelClass = "";
        let labelText = "";
        switch (rowData.status) {
          case 0:
            labelClass = "badge bg-warning";
            labelText = "A Vencer";
            break;
          case 1:
            labelClass = "badge bg-success";
            labelText = "Pago";
            break;
          case 2:
            labelClass = "badge bg-success";
            labelText = "Todos";
            break;
          default:
        }
        return (
          <span
            className={labelClass}
            style={{
              fontSize: "10px",
            }}
          >
            {labelText}
          </span>
        );
      },
    },
    {
      field: "due_date",
      header: "Data Vencimento",
      body: (rowData) => formatDate(rowData.due_date),
    },
    {
      field: "shipping_message_error",
      header: "Erro",
    },

  ];

  function sendReverse() {
    confirmDialog({
      message: "Deseja reenviar a remessa?",
      header: "Confirmação",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      accept: () => acceptInstallments(selectedCustomers),
    });
  }

  const acceptInstallments = async (parcels) => {

    const notification = toast.loading(
      "Por favor aguarde, reenviado remessa..."
    );
    const data = {};
    data.installments_id = [];
    data.enterprise_id = enterpriseId;
    parcels.forEach((p) => data.installments_id.push(p.id));

    console.log(data)

    try {
      await postReversalShipping(data);

      await generateShipping(data);
      refetch();
      setItemsSelected([]);
      setSelectedCustomers([]);
      toast.update(notification, {
        render: "Ação efetuada com sucesso!",
        autoClose: 2000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
    } catch (error) {
      console.log(error)
      // Caso um erro seja capturado, mostra o toast de erro
      const errorMessage =
        error.message || "Ocorreu um erro inesperado.";

      toast.update(notification, {
        render: errorMessage,
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        type: "error",
        isLoading: false,
      });

      await refetch(); // Refaz o refetch mesmo em caso de erro
    }
    finally {
      setIsModalVisibleReverseShipping(false);
    }
  };




  //  // console.log(selectedCustomers)

  return (
    <>
      <Modal
        dynamicTitle={dynamicTitle}
        id="modal_cad"
        onHide={() => {
          setIsModalVisibleReverseShipping(!isModalVisibleReverseShipping);
          setItemsSelected([]);
          setSelectAll2(false);
        }}
        visible={isModalVisibleReverseShipping}
        style={style}
      >
        <form onSubmit={handleUpdateParcel(sendReverse)}>
          <div>
            <h4>Parcelas com Erro na Remessa</h4>
          </div>
          <div className="px-0 py-3">
            <DataTable
              rows={25}
              paginator
              stripedRows
              showGridlines
              sortMode="multiple"
              selectionMode="multiple"
              rowsPerPageOptions={[5, 25, 100]}
              value={shippingWithError}
              selectAll={selectAll2}
              selection={selectedCustomers}
              onSelectionChange={onSelectionChange}
              onSelectAllChange={onSelectAllChange}
              globalFilter={globalFilterValue}
              emptyMessage="Nenhuma Informação foi encontrada."
              tableStyle={{ minWidth: "0.8rem", fontSize: "0.7rem" }}
            >
              <Column
                field="id"
                headerStyle={{ width: "3rem" }}
                selectionMode="multiple"
                filterMatchMode={FilterMatchMode.CONTAINS}
              />
              {columns.map((col) => (
                <Column
                  key={col.field}
                  field={col.field}
                  header={col.header}
                  body={col.body}
                />
              ))}
            </DataTable>
          </div>

          <div className="text-center mt-3">
            <Button
              rounded
              icon="fa fa-undo"
              severity="success"
              disabled={selectedCustomers.length === 0}
              label="Reenviar Remessa"
              className="p-inputtext-sm sme-2 m-auto"
            />
          </div>
        </form>
      </Modal>
    </>
  );
};

export default ModalReverseShipping;
